export const GRADIENT = "linear-gradient(135deg, #1B8DCD 0%, #232B5F 100%)";
export const GRADIENT2 = "linear-gradient(135deg, #14A05A, #1B8DCD)";

// PLEASE ADD a NEW COLORS TO THE END, CUZ ORDER METTER
export const COLORS = Object.freeze({
  $euiColorVis3Purple: "#9170bb",
  $brandGreen: "#14a05a",
  $euiColorVis1Blue: "#6092c0",
  $euiColorVis2DarkPink: "#d36086",
  $euiColorVis4Pink: "#ca8eae",
  $euiColorVis5Yellow: "#d6bf57",
  $euiColorVis6: "#b9a888",
  $euiColorVis0Green: "#4cd09f",
  $euiColorVis7Orange: "#da8b45",
  $euiColorPrimary: "#006BB4",
  $euiColorVis8: "#aa6556",
  $euiColorLightestShade: "#F5F7FA",
  $euiColorVis9DarkOrange: "#e7664c",
  $euiColorLightShade: "#D3DAE6",
  $euiColorYellow: "#FFC700",
  $euiRedColorAnomalies: "#ff5c5c",
  $euiColorDarkestShade: "#343741",
  $chartOrange: "#f5a700",
  $chartGreen: "#54b399",
  $blue: "#61a2ff",
  $euiColorDanger: "#ff5c5c",
  $euiColorMediumShade: "#98A2B3",
  $healthy: "#017d73",
  $euiColorWarning: "#f5a700",
  $lightBlue: "#03bfff",
  $medGrey: "#eceff4",
  $unhealthy: "#ff5c5c",
  $trendShadesGreen: "#4A9D6122",
  $trendShadesRed: "#ca000022",
  $trendShadesYellow: "#f5a70022",
  $buttonHover: "#0361a2",
  $hostHealth: "#6092cf85",
  $dbHealth: "#f7a7a385",
  $disabled: "#a2abba",
  $disabledBackground: "rgba(211, 218, 230, 0.15)",
  $white: "#fff",
  $integrationTiles: "#4d579b",
  $progressBlue: "#61a2ff",
  $progressGreen: "#36D399",
  $progressYellow: "#E0A23B",
  $progressRed: "#F0655C",
});
